import { useQuery } from '@tanstack/react-query'
import { listWorkspaces } from '@/services/workspaces/workspaceRepository'
import { getActiveWorkspaceId, useWorkspaceStore } from '@/store/workspaceStore'
import { isApiConfigured } from '@/config/api/env'
import { workspaceRepositoryUsesLocal } from '@/services/workspaces/workspaceRepositoryMode'

export const workspacesQueryKey = ['do-chat', 'workspaces']

export function useWorkspaces() {
  return useQuery({
    queryKey: workspacesQueryKey,
    queryFn: ({ signal }) => listWorkspaces({ signal }),
    enabled: isApiConfigured() || workspaceRepositoryUsesLocal(),
    retry: false,
    staleTime: 30_000,
  })
}

export function syncActiveWorkspace(workspaces = [], activeId = getActiveWorkspaceId()) {
  if (!workspaces.length) {
    if (activeId) useWorkspaceStore.getState().clearActiveWorkspace()
    return null
  }
  const match = workspaces.find((row) => row.id === activeId)
  if (!match && activeId) {
    useWorkspaceStore.getState().clearActiveWorkspace()
  }
  return match?.id ?? null
}
